import { useDevelopersQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { DevelopersContext } from './types'

const { Provider, useContextFn } =
  createStrictContext<DevelopersContext>('DevelopersContext')

export const useDevelopersContext = useContextFn

const DevelopersProvider: React.FC = ({ children }) => {
  const { data, loading, refetch } = useDevelopersQuery(DefaultQueryHookOptions)

  return (
    <Provider
      value={{
        users: data?.users.records ?? [],
        developers:
          data?.users.records.filter(({ developer }) => developer) ?? [],
        loading,
        refetch,
      }}
    >
      {children}
    </Provider>
  )
}

export default DevelopersProvider
